export enum TaskSortByOption {
    CREATED_ASC = 'created_asc',
    CREATED_DESC = 'created_desc',
    TARGET_DATE_ASC = 'target_date_asc',
    TARGET_DATE_DESC = 'target_date_desc',
    URGENCY_ASC = 'urgency_asc',
    URGENCY_DESC = 'urgency_desc',
}

export const sort_by_opts_de: Record<TaskSortByOption, string> = {
    [TaskSortByOption.CREATED_ASC]: 'Erstellt (aufstg.)',
    [TaskSortByOption.CREATED_DESC]: 'Erstellt (abstg.)',
    [TaskSortByOption.TARGET_DATE_ASC]: 'Zieldatum (aufstg.)',
    [TaskSortByOption.TARGET_DATE_DESC]: 'Zieldatum (abstg.)',
    [TaskSortByOption.URGENCY_ASC]: 'Wichtigkeit (aufstg.)',
    [TaskSortByOption.URGENCY_DESC]: 'Wichtigkeit (abstg.)',
};

export const sort_by_opts: { label: string; value: TaskSortByOption }[] = [
    {
        label: sort_by_opts_de[TaskSortByOption.CREATED_ASC],
        value: TaskSortByOption.CREATED_ASC,
    },
    {
        label: sort_by_opts_de[TaskSortByOption.CREATED_DESC],
        value: TaskSortByOption.CREATED_DESC,
    },
    {
        label: sort_by_opts_de[TaskSortByOption.TARGET_DATE_ASC],
        value: TaskSortByOption.TARGET_DATE_ASC,
    },
    {
        label: sort_by_opts_de[TaskSortByOption.TARGET_DATE_DESC],
        value: TaskSortByOption.TARGET_DATE_DESC,
    },
    {
        label: sort_by_opts_de[TaskSortByOption.URGENCY_ASC],
        value: TaskSortByOption.URGENCY_ASC,
    },
    {
        label: sort_by_opts_de[TaskSortByOption.URGENCY_DESC],
        value: TaskSortByOption.URGENCY_DESC,
    },
];
